import { validators } from 'utils/validators';
import { PAYMENT_GATEWAY_CREDENTIALS_FIELD_MAP } from '../constants';
import { PAYMENT_GATEWAY_ENUM } from '../constants';
const pgCredentialsOnboardingFormValidator = values => {
    console.log(values, "55");
    const { REQUIRE } = validators;
    let errors = { credentials: {} };
    if (REQUIRE(values.pgName)) {
        errors.pgName = 'PG Name is required';
    }
    if (REQUIRE(values.category)) {
        errors.category = 'Category is required';
    }
    if (REQUIRE(values.mcc)) {
        errors.mcc = 'MCC is required';
    }
    console.log("values...##", values);
    if (!values?.credentials?.merchantPGCode) {
        errors.credentials.merchantPGCode = 'Merchant PG Code is required';
    }
    // if (values.credentials) {
    //     if (REQUIRE(values.credentials.merchantPGKey)) {
    //         errors.credentials.merchantPGKey = 'Merchant PG Key is required';
    //     }

    // }
    // else {
    //     errors.credentials.merchantPGKey = 'Merchant PG Key is required';
    // }
    return errors;
};
const pgCredentialsPayModeFormValidator = values => {
    console.log(values, "values in paymode");
    const errors = {};
    const { REQUIRE } = validators;

    // if (values.debitCard && REQUIRE(values.debitCardBusinessSource)) {
    //     errors.debitCardBusinessSource = 'Debit Card Business Source is required when Debit Card is selected';
    // }
    // if (values.creditCard && REQUIRE(values.creditCardBusinessSource)) {
    //     errors.creditCardBusinessSource = 'Credit Card Business Source is required when Credit Card is selected';
    // }
    //At least one pay mode must be selected
    // if (!values.debitCard &&!values.creditCard &&!values.netbanking &&!values.wallets) {
    //     errors.wallets= 'Payment mode details should not be empty';
    // }
    return errors;
};
const pgCredentialsPricingFormValidator = values => {
    const { REQUIRE } = validators;
    const errors = {};
    return errors;
};
export {
    pgCredentialsOnboardingFormValidator,
    pgCredentialsPayModeFormValidator,
    pgCredentialsPricingFormValidator,
};
